import { larguraColunaCodigo, larguraColunaDescricao, larguraColunaOrdem, larguraColunaReferencia, larguraPrimeiraColuna } from "app/components/itens-orcamento/grid-itens/largurasColunasFixas"

const $ = require('jquery')

class ControleNavegacaoGridItens {

    novoInput: null

    obterQtdeLinhasEColunas(idTabela): number[] {

        // Antes usava tr:eq(2) (assumindo >= 2 linhas de item além do cabeçalho). Com 0 ou 1
        // item na grid essa linha não existe, find('td').length vira 0 e a matematica de
        // coordenadas (indice/0, indice%0) vira NaN — como NaN nunca é igual a NaN, a recursao
        // de moverParaProximoInput nunca detecta que parou de mover e estoura a pilha.
        const qtdeColunas = $(idTabela + " tr").filter((_, tr) => $(tr).find('td').length > 0).eq(0).find('td').length
        const qtdeLinhas = $(idTabela + " tr").length

        return [qtdeLinhas, qtdeColunas]
    }

    obterInput (idTabela, coordenadas) {
        const linha = coordenadas[0]
        const coluna = coordenadas[1]

        const qtdeColunas = this.obterQtdeLinhasEColunas(idTabela)[1]

        const indice = this.obterIndice1D(linha, coluna, qtdeColunas)

        return $(idTabela + " tr td").eq(indice).find('input')[0]


    }

    moverParaProximoInput (idTabela, linhaAtual, colunaAtual, direcao,inputOriginal) {
        const novasCoordenadas = this.obterNovasCoordenadas(idTabela, linhaAtual, colunaAtual, direcao)
        const novaLinha = novasCoordenadas[0]
        const novaColuna = novasCoordenadas[1]


        const coordenadasModificadas = (linhaAtual: number, novaLinha: number, colunaAtual: number, novaColuna: number) => {
            return linhaAtual != novaLinha || colunaAtual != novaColuna
        }

        const inputDesativado = (input) => {
            return input && input.attributes["disabled"] != null
        }

        const inputInvisivel = (input) => {
            return input.style.display == "none" || input.parentElement.style.display == "none"
        }

        const novoInput = this.obterInput(idTabela, novasCoordenadas)
        const inputAtual = this.obterInput(idTabela,[linhaAtual,colunaAtual])

        const inputEhNavegavel = input => $(input).hasClass("input-navegavel")

        if (novoInput == undefined || inputDesativado(novoInput) || inputInvisivel(novoInput) || !inputEhNavegavel(novoInput)) {
            if (coordenadasModificadas(linhaAtual, novaLinha, colunaAtual, novaColuna)) {
                this.moverParaProximoInput(idTabela, novaLinha, novaColuna, direcao,inputOriginal != null ? inputOriginal : inputAtual)
            } else {
                if (inputOriginal != null) {
                    inputOriginal.blur()
                    inputOriginal.select()
                }
            }

        } else {
            novoInput.select()
            this.fazerScrollParaElemento("#" + novoInput.getAttribute('id'))
            this.novoInput = novoInput
        }




    }

    obterNovasCoordenadas (idTabela, linhaAtual, colunaAtual, direcao) {
        const qtdeLinhasEColunas = this.obterQtdeLinhasEColunas(idTabela)
        const qtdeLinhas = qtdeLinhasEColunas[0]
        const qtdeColunas = qtdeLinhasEColunas[1]

        const indiceAtual = this.obterIndice1D(linhaAtual, colunaAtual, qtdeColunas)

        const strategyPorDirecao = {
            'esquerda': this.obterIndiceAEsquerda.bind(this),
            'direita': this.obterIndiceADireita.bind(this),
            'acima': this.obterIndiceAcima.bind(this),
            'abaixo': this.obterIndiceAbaixo.bind(this)
        }

        const novoIndice = strategyPorDirecao[direcao](indiceAtual, qtdeLinhas, qtdeColunas)

        const novasCoordenadas = this.obterCoordenadas2D(novoIndice, qtdeLinhas, qtdeColunas)

        return novasCoordenadas
    }

    obterIndiceAEsquerda (indiceAtual, _qtdeLinhas, _qtdeColunas) {
        return indiceAtual <= 0 ? indiceAtual : indiceAtual - 1
    }

    obterIndiceADireita (indiceAtual, qtdeLinhas, qtdeColunas) {
        return indiceAtual >= (qtdeLinhas * qtdeColunas - 1) ? indiceAtual : indiceAtual + 1
    }

    obterIndiceAcima (indiceAtual, qtdeLinhas, qtdeColunas) {
        const coordenadas = this.obterCoordenadas2D(indiceAtual, qtdeLinhas, qtdeColunas)

        const novaLinha = coordenadas[0] <= 0 ? 0 : coordenadas[0] - 1
        const coluna = coordenadas[1]

        return this.obterIndice1D(novaLinha, coluna, qtdeColunas)
    }

    obterIndiceAbaixo (indiceAtual, qtdeLinhas, qtdeColunas) {
        const coordenadas = this.obterCoordenadas2D(indiceAtual, qtdeLinhas, qtdeColunas)

        const novaLinha = coordenadas[0] >= qtdeLinhas - 1 ? coordenadas[0] : coordenadas[0] + 1
        const coluna = coordenadas[1]

        return this.obterIndice1D(novaLinha, coluna, qtdeColunas)
    }

    obterIndice1D (linha, coluna, qtdeColunas) {
        return linha * qtdeColunas + coluna
    }

    obterCoordenadas2D (indice, qtdeLinhas, qtdeColunas) {
        const linha = Math.floor(indice / qtdeColunas)
        const coluna = indice % qtdeColunas

        return [linha, coluna]
    }

    obterPosicaoInputNaTabela (input) {
        const celulaELinha = $(input).parents("td,tr")

        const indiceColuna = celulaELinha[0].cellIndex
        const indiceLinha = celulaELinha[1].rowIndex - 1

        return [indiceLinha, indiceColuna]
    }

    fazerScrollParaElemento(idElemento) {

        document.querySelector(idElemento).scrollIntoView({
            block: "center"
        })

    }


    tratarEvento(event,idTabela,input?) {
        if (event.ctrlKey || event.keyCode == '9') {    //keyCode = 9 => tab

            this.novoInput = null

            const direcao = event.keyCode == '38' ? 'acima' :
                      event.keyCode == '40' ? 'abaixo':
                      event.keyCode == '37' ? 'esquerda':
                      event.keyCode == '39' || event.keyCode == '9' ? 'direita' :
                      undefined

            if (direcao == undefined) {
                return;
            }

            const inputCorrigido = input || event.target

            if (inputCorrigido == undefined) {
                console.error('impossivel obter input para tratar evento de navegacao')
                return
            }

            const posicaoInputNaTabela = this.obterPosicaoInputNaTabela(inputCorrigido)
            const linhaAtual = posicaoInputNaTabela[0]
            const colunaAtual = posicaoInputNaTabela[1]


            if (linhaAtual == undefined || colunaAtual == undefined) {
                console.error('linha ou coluna atuais nao puderam ser identificadas')
                return
            }

            this.moverParaProximoInput(`#${idTabela}`,linhaAtual,colunaAtual,direcao,null)

            if (direcao == "esquerda" && this.novoInput != null) {

                const tratarRolagemHorizontalAEquerdaDevidoAColunasFixas = () => {

                    let tdNovoInput = null;
                    const numeroMaximoTentativasObterTdNovoInput = 5
                    let numeroTentativasObterTdNovoInput = 0
                    const self:any = this

                    do {
                        tdNovoInput = self?.novoInput?.parentElement
                        numeroTentativasObterTdNovoInput++
                    } while (numeroTentativasObterTdNovoInput == numeroMaximoTentativasObterTdNovoInput ? false : tdNovoInput.tagName != 'TD' ? true : false )

                    if (tdNovoInput != null) {
                        const offsetTdNovoInput = tdNovoInput.offsetLeft

                        const larguraPrimeiraColuna_ = document.getElementById('th-primeira-coluna-grid-itens') != null ? larguraPrimeiraColuna : 0
                        const larguraColunaOrdem_ = document.getElementById('th-coluna-OrdemItem-grid-itens') != null ? larguraColunaOrdem : 0
                        const larguraColunaCodigo_ = document.getElementById('th-coluna-Codigo-grid-itens') != null ? larguraColunaCodigo : 0
                        const larguraColunaReferencia_ = document.getElementById('th-coluna-Referencia-grid-itens') != null ? larguraColunaReferencia : 0
                        const larguraColunaDescricao_ = document.getElementById('th-coluna-Descricao-grid-itens') != null ? larguraColunaDescricao : 0

                        const larguraTotalColunasFixas = larguraPrimeiraColuna_ + larguraColunaOrdem_ + larguraColunaCodigo_ + larguraColunaReferencia_ + larguraColunaDescricao_

                        // console.log(`larguraPrimeiraColuna_`, larguraPrimeiraColuna_)
                        // console.log(`larguraColunaOrdem_`, larguraColunaOrdem_)
                        // console.log(`larguraColunaCodigo_`, larguraColunaCodigo_)
                        // console.log(`larguraColunaReferencia_`, larguraColunaReferencia_)
                        // console.log(`larguraColunaDescricao_`, larguraColunaDescricao_)
                        // console.log(`larguraTotalColunasFixas`, larguraTotalColunasFixas)

                        document.getElementById('container-rolavel-grid-itens').scrollLeft = offsetTdNovoInput - larguraTotalColunasFixas
                    }
                }

                tratarRolagemHorizontalAEquerdaDevidoAColunasFixas()

            }

            event.preventDefault()
        }
    }
}

export const controleNavegacaoGridItens = new ControleNavegacaoGridItens()
